import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
let _cachedFlag = null;
let _inflight = null;

/**
 * Reads the public `/api/ui/social-proof` flag once per session.
 * Returns `null` while loading, `true`/`false` after. Defaults to `false`
 * on any fetch failure so the noisy widgets stay HIDDEN if the API is down.
 */
export function useSocialProofEnabled() {
  const [enabled, setEnabled] = useState(_cachedFlag);

  useEffect(() => {
    if (_cachedFlag !== null) {
      setEnabled(_cachedFlag);
      return;
    }
    if (!_inflight) {
      _inflight = axios
        .get(`${API}/api/ui/social-proof`, { timeout: 8000 })
        .then((r) => {
          _cachedFlag = !!r.data?.enabled;
          return _cachedFlag;
        })
        .catch(() => {
          _cachedFlag = false;
          return false;
        });
    }
    let cancelled = false;
    _inflight.then((v) => { if (!cancelled) setEnabled(v); });
    return () => { cancelled = true; };
  }, []);

  return enabled;
}
